import { Routes } from "../../../modules/routing/Routes"
import { useInjector } from "../../injector/hooks/useInjector"

export const useRoutes = (): Routes => useInjector().routes
